export default "__VITE_ASSET__BqL9xxTP__"